import type {
  CellAnnotationWireEntry,
  CellAnnotationWireMap,
} from 'components/CellAnnotationValueViewer/types';

// Shared fold helper for the Pre-FX save splitters (FOD / CFL / Security).
// Folds one dirty cell-annotation entry into a per-parent bucket keyed
// (parentId -> fieldAlias -> annotationType -> entry). Last write wins.
export const foldEntry = (
  bucket: Record<string, CellAnnotationWireMap>,
  parentId: string,
  fieldAlias: string,
  annotationType: string,
  entry: CellAnnotationWireEntry
): void => {
  // eslint-disable-next-line no-param-reassign
  const forParent = bucket[parentId] ?? (bucket[parentId] = {});
  const forField = forParent[fieldAlias] ?? (forParent[fieldAlias] = {});
  forField[annotationType as keyof typeof forField] = entry;
};
